import { AxiosInstance } from 'axios';
import { useCallback } from 'react';
import { UPDATE_WORKFLOW_MUTATION } from '../apollo/mutations/workflow-mutation';
import { useLoading } from './useLoading';

export const useUpdateWorkflow = ({
  api,
  workspaceId,
}: {
  api: AxiosInstance;
  workspaceId: string;
}) => {
  const updateWorkflow = useCallback(
    async (body) => {
      const { data } = await api.request(
        {
          data: {
            operationName: 'updateWorkflow',
            variables: {
              workflow: {
                id: body.id,
                definition: body.definition,
                name: body.name,
                workspaceId,
              },
            },
            query: UPDATE_WORKFLOW_MUTATION,
          }
        },
      );

      return data;
    },
    [api, workspaceId],
  );

  return useLoading(updateWorkflow);
};
